import React from 'react'
import { StyledKarteInputForm, Props } from './styled'

// ATTENTION!
// このコンポーネントはカルテ（登録直後のカルテ、プロフィールシート内のカルテ）でのみ使用されます。
// 新しいコンポーネントでラベルコンポーネントを使用する場合は、InputFormコンポーネントを使用してください。
export const KarteInputForm: React.FC<Props> = (props: Props) => {
  return <StyledKarteInputForm {...props} />
}
